import { render, staticRenderFns } from "./UserFilesWidget.vue?vue&type=template&id=0c2625f0&scoped=true&"
import script from "./UserFilesWidget.vue?vue&type=script&lang=js&"
export * from "./UserFilesWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserFilesWidget.vue?vue&type=style&index=0&id=0c2625f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2625f0",
  null
  
)

export default component.exports